import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { 
  FaUniversity, 
  FaExchangeAlt, 
  FaShieldAlt, 
  FaUsers,
  FaInfoCircle,
  FaHandshake,
  FaBook,
  FaGraduationCap
} from 'react-icons/fa';
import Layout from '../components/layout/Layout';
import './LegalPages.css';

const AboutUs = () => {
  return (
    <Layout>
      <Container className="legal-page">
        <Row className="justify-content-center">
          <Col lg={10}>
            <h1 className="page-title text-center mb-4">
              <FaUniversity className="me-2" />
              About UniTrade
            </h1>
            
            <section className="mb-5">
              <h2 className="section-title">
                <FaInfoCircle className="me-2" />
                Our Mission
              </h2>
              <p className="lead">
                At UniTrade, we're dedicated to creating a seamless and secure marketplace for university students to buy, sell, and trade items within their campus community.
              </p>
          </section>

          <section className="mb-5">
            <h2 className="section-title">
              <FaHandshake className="me-2" />
              Why Choose UniTrade?
            </h2>
            <Row className="g-4">
              <Col md={6} lg={3}>
                <Card className="h-100 feature-card">
                  <Card.Body className="text-center">
                    <div className="feature-icon mb-3">
                      <FaUniversity size={40} />
                    </div>
                    <h4>University Focused</h4>
                    <p>Designed specifically for university students by students.</p>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={6} lg={3}>
                <Card className="h-100 feature-card">
                  <Card.Body className="text-center">
                    <div className="feature-icon mb-3">
                      <FaExchangeAlt size={40} />
                    </div>
                    <h4>Easy Trading</h4>
                    <p>Simple and secure transactions within your campus.</p>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={6} lg={3}>
                <Card className="h-100 feature-card">
                  <Card.Body className="text-center">
                    <div className="feature-icon mb-3">
                      <FaShieldAlt size={40} />
                    </div>
                    <h4>Safe & Secure</h4>
                    <p>Verified student accounts for your peace of mind.</p>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={6} lg={3}>
                <Card className="h-100 feature-card">
                  <Card.Body className="text-center">
                    <div className="feature-icon mb-3">
                      <FaUsers size={40} />
                    </div>
                    <h4>Community Driven</h4>
                    <p>Built by students, for students.</p>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </section>

          <section className="mb-5">
            <h2 className="section-title">
              <FaBook className="me-2" />
              Our Story
            </h2>
            <p>
              UniTrade was founded in 2023 by a group of university students who were frustrated with the lack of a dedicated platform for buying and selling items within their campus. 
              What started as a class project quickly grew into a full-fledged platform serving thousands of students across multiple universities.
            </p>
          </section>

          <section>
            <h2 className="section-title">
              <FaGraduationCap className="me-2" />
              Join Our Community
            </h2>
            <p>
              Whether you're looking to sell your old textbooks, buy affordable electronics, or simply connect with fellow students, 
              UniTrade is here to make your campus life easier and more affordable.
            </p>
          </section>
        </Col>
        </Row>
      </Container>
    </Layout>
  );
};

export default AboutUs;
